import { render, staticRenderFns } from "./StcvPD.vue?vue&type=template&id=b3288b10"
import script from "./StcvPD.vue?vue&type=script&lang=js"
export * from "./StcvPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports